module.exports = __webpack_public_path__ + "img/bosporus.9c1147d8.jpg";